import React from "react";
import { Entry } from "@store/types";
import { State, getDirectory } from "@store";
import { useSelector, useDispatch } from "react-redux";

type Data<T> = [T, Error | null, boolean];

export function useDirectory(search: string): Data<Entry[] | null> {
  const dispatch = useDispatch();
  const [directory_users, error, fetching] = useSelector((state: State) => [
    state.directory[search],
    state.network.error.directory[search],
    state.network.fetching.directory[search],
  ]);

  React.useEffect(() => {
    if (!directory_users && !fetching && !error) {
      dispatch(getDirectory(search));
    }
  }, [search, dispatch, directory_users, error, fetching]);

  return [directory_users, error, fetching];
}
